export default __webpack_public_path__ + "76e133fedab4b0a60713af5cfc003ca6.svg";